import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/compare/archer')({
  head: () => ({
    ...buildSeoHead({ path: '/compare/archer', ...ROUTE_META['/compare/archer'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Compare', path: '/compare' }, { name: 'Archer', path: '/compare/archer' }])),
      jsonLdScript(buildWebPageSchema({ path: '/compare/archer', ...ROUTE_META['/compare/archer'] })),
    ],
  }),
});
